export const maximumUsers = {
    active: true,
    maxUsers: 28
};